/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShipPositionPostRequest
 */
export interface ShipPositionPostRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ShipPositionPostRequest
     */
    imo?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShipPositionPostRequest
     */
    mmsi?: Array<number>;
}

/**
 * Check if a given object implements the ShipPositionPostRequest interface.
 */
export function instanceOfShipPositionPostRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipPositionPostRequestFromJSON(json: any): ShipPositionPostRequest {
    return ShipPositionPostRequestFromJSONTyped(json, false);
}

export function ShipPositionPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipPositionPostRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'imo': !exists(json, 'imo') ? undefined : json['imo'],
        'mmsi': !exists(json, 'mmsi') ? undefined : json['mmsi'],
    };
}

export function ShipPositionPostRequestToJSON(value?: ShipPositionPostRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'imo': value.imo,
        'mmsi': value.mmsi,
    };
}

